import { defineConfig } from "../config";
import { authHeader } from "../helpers";
import { utilsService } from "./utils";
const { handleResponse } = utilsService;

export const advertiserService = {
    getAllAdvertiser,
    getAdvertiserById,
    getAllAdvertiserName,
    getAllBusinessArea,
    getAllRoles,
    checkUnicity,
    getAllPaginatedAndFiltered,
    createAdvertiser,
    deleteAdvertiser,
    getAdvertiserImage,
    updateAdvertiser,
    uploadLogo,
    deleteLogo,
    updateAdvertiserLogo,
    getAllContacts,
  };

  const { apiUrl } = defineConfig.ADVERTISER_SERVICE;
  const apiUrlAdvertiser = apiUrl + "advertiser/";

  function getAllAdvertiser() {
    const url = apiUrlAdvertiser + `getAll`;

    const requestOptions = {
      method: "GET",
      headers: authHeader("application/json"),
    };
  
    return fetch(
      url,
      requestOptions
    )
      .then(handleResponse)
      .then(res => {
        return res;
      });
  }


function getAllPaginatedAndFiltered(page = 0, perPage = 10, queryParams = '') {
  let url = `${apiUrlAdvertiser}allPaginated/page/${page}/perPage/${perPage}`;
  
  if (queryParams) {
    if (typeof queryParams === 'string') {
      const queryString = queryParams.startsWith('?') ? queryParams.substring(1) : queryParams;
      url += `?${queryString}`;
    } else if (typeof queryParams === 'object') {
      const queryString = Object.entries(queryParams)
        .filter(([key, value]) => value !== null && value !== undefined && value !== '')
        .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
        .join('&');
      
      if (queryString) {
        url += `?${queryString}`;
      }
    }
  }

  const requestOptions = {
    method: "GET",
    headers: authHeader("application/json"),
  };

  return fetch(url, requestOptions)
    .then(handleResponse)
    .then(res => {
      return res;
    });
}

  function getAdvertiserById(id) {
    const url = apiUrlAdvertiser + `getById?id=${id}`;
  
    const requestOptions = {
      method: "GET",
      headers: authHeader("application/json"),
    };
  
    return fetch(
      url,
      requestOptions
    )
      .then(handleResponse)
      .then(res => {
        return res;
      });
  }

  function getAllAdvertiserName(){

    const url = apiUrlAdvertiser + `getAdvertiserName`;
    const requestOptions = {
      method: "GET",
      headers: authHeader("application/json"),
    };
  
    return fetch(
      url,
      requestOptions
    )
      .then(handleResponse)
      .then(res => {
        return res;
      });
  }
  function getAllBusinessArea(){

    const url = apiUrlAdvertiser + `businessArea/all`;
    const requestOptions = {
      method: "GET",
      headers: authHeader("application/json"),
    };
  
    return fetch(
      url,
      requestOptions
    )
      .then(handleResponse)
      .then(res => {
        return res;
      });
  }

  function getAllRoles(){

    const url = apiUrlAdvertiser + `getRoles`;
    const requestOptions = {
      method: "GET",
      headers: authHeader("application/json"),
    };
  
    return fetch(
      url,
      requestOptions
    )
      .then(handleResponse)
      .then(res => {
        return res;
      });
  }

  function checkUnicity(field,value){

    const url = apiUrlAdvertiser + `checkUnicity/${field}?value=${value}`;
    const requestOptions = {
      method: "GET",
      headers: authHeader("application/json"),
    };
  
    return fetch(
      url,
      requestOptions
    )
      .then(handleResponse)
      .then(res => {
        return res;
      });
  }

  function createAdvertiser(advertiserData) {
    const url = apiUrlAdvertiser + `create`;
    const requestOptions = {
      method: "POST",
      headers: authHeader("application/json"),
      body: JSON.stringify(advertiserData)
    };
  
    return fetch(url, requestOptions)
      .then(handleResponse)
      .then(res => {
        return res;
      });
  }
  
  function deleteAdvertiser(id) {
    const url = apiUrlAdvertiser + "delete?id=" + id;
  
    const requestOptions = {
      method: "DELETE",
      headers: authHeader("application/json"),
    };
  
    return fetch(
      url,
      requestOptions
    )
      .then(handleResponse)
      .then(res => {
        return res;
      });
  }
  function getAdvertiserImage(imageId) {
    const url = apiUrlAdvertiser + `image/get/${imageId}`;
    const requestOptions = {
      method: "GET",
      headers: authHeader()
    };
  
    return fetch(url, requestOptions)
      .then(response => {
        if (!response.ok) {
          throw new Error('Errore nel caricamento dell\'immagine');
        }
        return response.blob();
      });
  }

  function updateAdvertiser(advertiserData) {
    const url = apiUrlAdvertiser + `update`;
    const requestOptions = {
      method: "PUT",
      headers: authHeader("application/json"),
      body: JSON.stringify(advertiserData)
    };

    return fetch(url, requestOptions)
      .then(handleResponse)
      .then(res => {
        return res;
      });
  }

  function uploadLogo(formData) {
    const url = apiUrlAdvertiser + `image/upload`;
    const requestOptions = {
      method: "POST",
      headers: authHeader(), 
      body: formData
    };

    return fetch(url, requestOptions)
      .then(response => {
        if (!response.ok) {
          return response.text().then(text => {
            throw new Error(`Errore nell'upload del logo: ${response.status} - ${text}`);
          });
        }
        return response.json();
      })
      .then(data => {
        // La risposta dovrebbe essere nel formato:
        // {
        //   "id": "string",
        //   "fileName": "string", 
        //   "contentType": "string",
        //   "creationDate": "2025-07-22T09:11:39.846Z"
        // }
        return data;
      })
      .catch(error => {
        console.error('Errore durante l\'upload del logo:', error);
        throw error;
      });
  }

  function deleteLogo(logoId) {
    const url = apiUrlAdvertiser + `image/delete/${logoId}`;
    const requestOptions = {
      method: "DELETE",
      headers: authHeader()
    };

    return fetch(url, requestOptions)
      .then(response => {
        if (!response.ok) {
          return response.text().then(text => {
            throw new Error(`Errore nell'eliminazione del logo: ${response.status} - ${text}`);
          });
        }
        if (response.status === 204) {
          return {};
        }
        return response.json();
      })
      .catch(error => {
        console.error('Errore durante l\'eliminazione del logo:', error);
        throw error;
      });
  }

  function updateAdvertiserLogo(advertiserId, advertiserImage) {
    const url = apiUrlAdvertiser + `updateLogo/${advertiserId}`;
    
    const requestOptions = {
      method: "PUT",
      headers: authHeader("application/json"),
      body: JSON.stringify(advertiserImage) 
    };

    return fetch(url, requestOptions)
      .then(response => {
        if (!response.ok) {
          return response.text().then(text => {
            throw new Error(`Errore nell'aggiornamento del logo: ${response.status} - ${text}`);
          });
        }
        if (response.status === 204) {
          return {};
        }
        return response.json();
      })
      .catch(error => {
        console.error('Errore durante l\'aggiornamento del logo:', error);
        throw error;
      });
  }

  function getAllContacts () {
    const url = apiUrlAdvertiser + `contact/all/dto`;

    const requestOptions = {
      method: "GET",
      headers: authHeader("application/json"),
    };
  
    return fetch(
      url,
      requestOptions
    )
      .then(handleResponse)
      .then(res => {
        return res;
      });
  }